<section
  class="account-history-screen tw-w-full"
  data-cy="acc-history-screen"
>
  <!-- Heading bar with close affordance (mirrors Account Settings) -->
  <header
    class="
      heading-section
      tw-flex
      tw-h-[58.5px]
      tw-items-center
      tw-justify-between
      tw-bg-[#F0F0F0]
      tw-rounded-[12px]
      tw-p-[10px_18px]
      tw-mb-[16px]
    "
    data-cy="acc-history-header"
  >
    <h3
      class="tw-font-bold tw-text-[18px] tw-text-[#000000] tw-tracking-[0.5px] tw-m-0"
      data-cy="acc-history-title"
    >
      {{ 'ui.account.account.history' | translate: 'Account History' }}
    </h3>
    <button
      type="button"
      (click)="close()"
      class="
        acc-history-close
        tw-flex
        tw-items-center
        tw-justify-center
        tw-bg-transparent
        tw-border-0
        tw-cursor-pointer
      "
      attr.aria-label="{{ 'ui.account.close.account.history' | translate: 'Close account history' }}"
      data-cy="acc-history-close"
    >
      <mat-icon class="!tw-text-[22px] tw-text-[#000000]">close</mat-icon>
    </button>
  </header>

  <!-- History list — expandable Statements + coming-soon actions.
       The active row hides the others via [hidden] driven by
       AccountHistoryService state. -->
  <mat-accordion class="my-history-section" displayMode="flat">
    @for (row of rows; track trackByRowId($index, row)) {

      <!-- Expandable rows (Statements) -->
      @if (row.expandable) {
        <mat-expansion-panel
          class="history-row"
          [ngClass]="{
            'tw-rounded-[12px] tw-border tw-border-[#E0E0E0]!': activeRow === row.id,
            'active': activeRow === row.id
          }"
          [class.active]="activeRow === row.id"
          [hidden]="isRowHidden(row.id)"
          [expanded]="activeRow === row.id"
          (opened)="onRowToggle(row.id, true)"
          (closed)="onRowToggle(row.id, false)"
          [attr.data-cy]="row.dataCy"
          [attr.data-name]="row.id"
        >
          <mat-expansion-panel-header class="history-row-header">
            <mat-panel-title class="tw-flex tw-items-center">
              <img
                [src]="row.iconLight"
                class="l-mode tw-w-[28px] tw-inline tw-mr-[22px]"
                [alt]="row.label + ' icon (light)'"
              >
              <img
                [src]="row.iconDark"
                class="d-mode tw-w-[28px] tw-inline tw-mr-[22px]"
                [alt]="row.label + ' icon (dark)'"
              >
              <span class="tw-text-[16px] tw-text-[#000000]">{{ row.label }}</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <!-- Row body — mounted only while the row is open. -->
          @switch (row.id) {
            @case ('statements') {
              <div class="card-body tw-py-[12px]" data-cy="statements-body">
                @if (activeRow === 'statements') {
                  <feature-mat-statements></feature-mat-statements>
                }
              </div>
            }
            @case ('betSummary') {
              <div class="card-body tw-py-[12px]" data-cy="bet-summary-body">
                @if (activeRow === 'betSummary') {
                  <feature-mat-account-bet-summary></feature-mat-account-bet-summary>
                }
              </div>
            }
            @case ('overview') {
              <div class="card-body tw-py-[12px]" data-cy="overview-body">
                @if (activeRow === 'overview') {
                  <feature-mat-account-overview></feature-mat-account-overview>
                }
              </div>
            }
          }
        </mat-expansion-panel>
      }

      <!-- Non-expandable rows — coming-soon actions -->
      @if (!row.expandable) {
        <button
          type="button"
          class="history-row history-row-action"
          [hidden]="isRowHidden(row.id)"
          (click)="openComingSoon()"
          [attr.data-cy]="row.dataCy"
          [attr.data-name]="row.id"
        >
          <img
            [src]="row.iconLight"
            class="l-mode tw-inline tw-mr-[19px]"
            [alt]="row.label + ' icon (light)'"
          >
          <img
            [src]="row.iconDark"
            class="d-mode tw-inline tw-mr-[19px]"
            [alt]="row.label + ' icon (dark)'"
          >
          <span class="tw-text-[16px] tw-flex-1 tw-text-left">{{ row.label }}</span>
          <mat-icon class="chev-right !tw-text-[#000000]">chevron_right</mat-icon>
        </button>
      }
    }
  </mat-accordion>
</section>
